//  Закомментируйте строку ниже если блок "Спикеры" не будет использоваться
import SpeakersConfiguration from '@/configurations/content/wecloud/speakers'
//  Закомментируйте строку ниже если блок "Партнеры" не будет использоваться
import PartnersConfiguration from '@/configurations/content/wecloud/partners' // @/configurations/content/vtb/partners-dark для темной темы

export default {
  pageTitle: 'PostgreSQL, MongoDB, Redis в облаке: с чего начать',
  logo: {
    image: require('@/assets/logo/Cloud color.png'), // @/assets/logo/logo-white.svg для темной темы
    alt: 'T1 logo'
  },
//  pageBackgroundImage: require('@/assets/background/background.jpg'), // путь до кастомного фона
  aboutActivity: {
    name: 'PostgreSQL, MongoDB, Redis в облаке: с чего начать',
  description: [
    '<b>Главное – порядок в данных, а остальное СУБД. </b>',
    'Без СУБД (системы управления базой данных) уже невозможно представить работу с базой данных. PostgreSQL, MongoDB, Redis — привычные инструменты разработчиков, которые можно развернуть самостоятельно или с помощью Managed Service.',
    'Для того, чтобы принять решение, как действовать, приглашаем на бесплатный вебинар «PostgreSQL, MongoDB, Redis в облаке: с чего начать» на котором расскажем:',
    '',
    '<ul> <li>Как развернуть базу данных нажатием одной кнопки</li> <li>Что включает в себя архитектура Managed Services</li> <li>Что делать, если Junior-разработчик удалил часть базы данных. Проводим восстановление в прямом эфире.</li> <li>О распределении зон ответственности T1 Cloud и клиента</li>',
    '',
    '',
    '',
    '',
    '',
    'До встречи 16 апреля в 11:00 МСК!'
  ],
  date: '16.04.2024',
  time: '11:00 МСК'
  },
  activities: [
    {
      tabName: '15.06.3023', // название таба, при многозальном мероприятии
      items: [
        {
          hash: 'jmlJMEGx',
          id: 2286,
          hallName: 'Первый зал' // название зала
        }
      ]
    }
  ],
  player: {
    title: 'Трансляция' // заголовок блока "Плеер"
  },
  schedule: {
    title: 'Программа' // заголовок блока "Расписание"
  },
  speakers: {
    //  Закомментируйте строку ниже если блок "Спикеры" не будет использоваться
    items: SpeakersConfiguration,
    title: 'Спикеры', // заголовок блока "Спикеры"
    shape: 'circle' // форма фотографий спикеров ('square' - квадрат, 'circle' - круг)
  },
  imageBlock: {
    title: 'Как пройти', // заголовок Блока с картинкой (оставить пустым (''), если не нужен)
    image: require('@/assets/image-block/image.jpg'), // путь до изображения для блока с картинкой
    items: [
      'Этот блок состоит из текстового описания и картинки с пропорциями квадрата. Чаще всего мы сюда помещаем информацию о том, как добраться до места проведения мероприятия, что нужно с собой взять (например, паспорт).',
      'Можно добавить информацию о наличии парковочных мест.',
      'Можно дать ссылку на <a href="https://t1-cloud.ru" target="_blank">T1 Cloud</a>'
    ]
  },
  info: {
    title: 'Организатор', // заголовок Текстового блока (оставить пустым (''), если не нужен)
    items: [
      '<a href="https://t1-cloud.ru" target="_blank">T1 Cloud</a> – российский облачный провайдер, входит в многопрофильный холдинг T1.',
      'Мы помогаем компаниям разных отраслей и масштаба в оптимизации ИТ-инфраструктуры, обеспечении непрерывности бизнеса и ускорении процессов. Предоставляем комплексные решения с использованием публичных, частных и гибридных облаков. Нашим клиентам доступен широкий портфель облачных сервисов по моделям IaaS, PaaS, SaaS, а также стек импортонезависимых решений на базе отечественных технологий для выполнения широкого спектра задач любой сложности.',
      '<a href="https://t1-cloud.ru/"><img style="margin-right:50px" src="assets/image-block/globe.png" </a><a href="https://t.me/T1Holding"><img style="margin-right:50px" " src="assets/image-block/telegram.png" </a><a href="https://vk.com/t1_cloud"><img style="margin-right:50px" src="assets/image-block/vk-1.png" </a><a href="https://www.youtube.com/@t1-cloud"><img style="margin-right:50px" " src="assets/image-block/youtube-1.png" </a>',
      '<a href="https://clck.ru/39XhmL" target="_blank">Подписка на рассылку</a>',
      'Почта: <a href="https://mailhost.pikemedia.live/SOGo/so/e.belevskiy@mashroom.online/Mail/UIxMailPopupView#!/Mail/0/new?mailto:team@t1-cloud.ru" target="_blank">team@t1-cloud.ru</a>'
    ]
  },
  partners: {
    //  Закомментируйте строку ниже если блок "Партнеры" не будет использоваться
    items: PartnersConfiguration,
    title: 'Партнеры' // заголовок блока "Партнёры"
  },
  footer: {
    copyright: '© Холдинг Т1,'
    // phone: '+7 926 260 53 22'
  }
}
